import { FC } from 'react';
import { CircularProgress } from '../CircularProgress/CircularProgress';

export const LoadingIndicator: FC = () => (
  <div className="flex items-center justify-center" data-testid="loading-icon">
    <CircularProgress />
  </div>
);
